import React from 'react';
import { BaseComponent } from './BaseComponent.js';
import { BaseTemplate } from './BaseTemplate.js';
import $ from 'jquery';
import FontAwesome from 'react-fontawesome';
import moment from 'moment';
import { Pie } from 'react-chartjs-2';
import BarChart from './dashboard/BarChart';
import LineChart from './dashboard/LineChart';
import PieChart from './dashboard/PieChart';
import DashboardAddModule from './dashboard/DashboardAddModule';

export class Dashboard extends BaseComponent {
  constructor(props) {
    super(props);

    let startDate = moment().subtract(1,'d');
    startDate = moment(startDate.format('YYYY-MM-DD') + ' 00:00:00', "YYYY-MM-DD HH:mm:ss");
    // startDate = moment('2018-06-23 00:00:00', "YYYY-MM-DD HH:mm:ss");
    let endDate = moment(moment().format('YYYY-MM-DD') + ' 23:59:59', "YYYY-MM-DD HH:mm:ss");
    // endDate = moment('2018-06-28 23:59:59', "YYYY-MM-DD HH:mm:ss");

    this.state = {
      devices: '',
      subDevices: [],
      tunnel: '',
      data: [],
      dataPreFormat: [],
      data_time_i: [],
      data_time_h: [],
      data_time_d: [],
      limit: 1000,
      startDate: startDate,
      endDate: endDate,
      graphData: [],
      userEmail: '',
      devicesGraph: [],
      modules: [],
      popupGraph: false,
      openAjax: -1,
      address: [],
      currentGraph: '',
      editModule: {},
    };

    this.getDevices = this.getDevices.bind(this);
    this.getDashboardData = this.getDashboardData.bind(this);
    this.getSubdevices = this.getSubdevices.bind(this);
    this.getSavedData = this.getSavedData.bind(this);
    this.removeModule = this.removeModule.bind(this);
    this.changeDataGroup = this.changeDataGroup.bind(this);
    this.changeHours = this.changeHours.bind(this);
    this.checkAjaxOpen = this.checkAjaxOpen.bind(this);
    this.refreshDashboard = this.refreshDashboard.bind(this);
    this.saveGraphsToDb = this.saveGraphsToDb.bind(this);
    this.updateDataAfterAjax = this.updateDataAfterAjax.bind(this);
    this.formatData = this.formatData.bind(this);
    this.editModule = this.editModule.bind(this);
    this.removeEditModule = this.removeEditModule.bind(this);
  }

  componentDidMount() {
    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: 'GetUserInfo',
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res, status, jqXHR) => {
        this.setState({ userEmail: res.Email });
        this.getDashboardData();
        // setInterval(() => {
        //   console.log('subdevices');
        //   this.updateSubdevices();
        // }, 5000);
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  getDashboardData() {
    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: 'GetUserInfo',
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res, status, jqXHR) => {
        if (res) {
          let dashboardModules = [];
          if (res.Extra) {
            dashboardModules = JSON.parse(atob(res.Extra));
          }
          let i = 0;
          let modules = [];
          while (i < dashboardModules.length) {
            dashboardModules[i].id = i+1;
            dashboardModules[i].startDate = this.state.startDate;
            dashboardModules[i].endDate = this.state.endDate;
            modules.push(dashboardModules[i]);
            i++;
          }

          this.setState({ modules: modules }, () => {
            this.getDevices();
          });
        }
      },
      error: (httpReq, status, exception) => {
        this.setState({ error: 1 });
      },
    });
  }

  getSavedData(deviceID, offset, queue = 0) {
    if (isNaN(offset)) {
      offset = 0;
    } else {
      offset = parseInt(offset, 10) + parseInt(this.state.limit, 10);
    }

    let data = {
      Action: 'GetStoredData',
      DeviceID: deviceID,
      Offset: offset,
      Queue: queue,
      Limit: this.state.limit,
    };
    if (this.state.startDate) {
      data.From = parseInt(this.state.startDate.format('X'), 10);
    }
    if (this.state.endDate) {
      data.To = parseInt(this.state.endDate.format('X'), 10);
    }
    data = JSON.stringify(data);

    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      dataType: 'json',
      data: data,
      xhrFields: {
        withCredentials: true
      },
      success: (res) => {
        let i = 0;
        let data = this.state.data;
        let dataPreFormat = this.state.dataPreFormat;

        while (i < res.Data.length) {
          res.Data[i]['timestamp'] = res.Timestamp[i];

          if (!data[deviceID]) {
            data[deviceID] = [];
          }

          let j = 0;
          // CICLO ALL'INTERNO DEI SENSORI
          // ZIGBEE - DATI PER GRAFICO
          if (res.Data[i].Nodes) {
            while (j < res.Data[i].Nodes.length) {
              let sensor = res.Data[i].Nodes[j];
              // CICLO ALL'INTERNO DEGLI ENDPOINT
              if (this.state.address.indexOf(sensor.IEEEAddress) !== -1) {
                let z = 0;
                while (z < sensor.Endpoints.length) {
                  let endpoint = sensor.Endpoints[z];
                  endpoint.IEEEAddress = sensor.IEEEAddress;
                  endpoint.gatewayID = deviceID;
                  endpoint.timestamp = res.Timestamp[i];
                  endpoint.type = 'zigbee';
                  dataPreFormat.push(endpoint);
                  z++;
                }
              }
              j++;
            }
          } else {
            // MODBUS - DATI PER GRAFICO
            let sensor = res.Data[i];
            let z = 0;

            while (z < sensor.length) {
              let endpoint = sensor[z];
              if (this.state.address.indexOf(endpoint.Id) !== -1) {
                endpoint.IEEEAddress = endpoint.Id;
                endpoint.gatewayID = deviceID;
                endpoint.timestamp = res.Data[i].timestamp;
                endpoint.type = 'modbus';
                dataPreFormat.push(endpoint);
              }
              z++;
            }
            j++;
          }
          i++;
        }

        this.setState({ data: data, dataPreFormat: dataPreFormat }, () => {
          // CODA 0 -> zigbee
          if (queue === 0) {
            // Cerco se ci sono altri dati oltre ai 1000 di limite
            if (res.Limit === res.Count) {
              this.getSavedData(deviceID, res.Offset, queue);
            } else {
              // passo al reperimento dati in modbus che risiedono sulla coda 1
              this.getSavedData(deviceID, null, 100);
            }
          // CODA 1 -> modbus
          } else if(queue === 100) {
            if (res.Limit === res.Count) {
              this.getSavedData(deviceID, res.Offset, queue);
            } else {
              let openAjax = this.state.openAjax-1;
              this.setState({ openAjax: openAjax}, () => {
                if (this.state.openAjax === 0) {
                  this.formatData();
                  this.setState({ popupGraph: true });
                }
              });
            }
          }
        });
      },
      error: (httpReq, status, exception) => {
        console.log(httpReq);
        console.log(status);
        console.log(exception);
      },
    });
  }

  formatData() {
    let data_time_d = [];
    let data_time_h = [];
    let data_time_i = [];

    let i = 0;
    while (i < this.state.dataPreFormat.length) {
      let endpoint = this.state.dataPreFormat[i];

      let timestampRounded = moment.unix(endpoint.timestamp);

      // PER OGNI DATO SALVATO MODIFICO LA SUA DATA ARROTONDANDOLA
      let timestampRoundedFormat;

      // SALVO 3 DATE_TIME GIÀ FORMATTATI
      // FORZO A MINUTI
      timestampRoundedFormat = timestampRounded.format('YYYY-MM-DD HH:mm');
      timestampRoundedFormat = moment(timestampRoundedFormat + ':00', 'YYYY-MM-DD HH:mm:ss');

      timestampRoundedFormat = timestampRoundedFormat.format('X');
      endpoint.timestampRounded = timestampRoundedFormat;
      // FINE MODIFICA DATA - POI AGGIUNGO I DATI SOMMANDOLI

      // SMISTAMENTO DATI CON ARROTONDAMENTO
      if (!data_time_i[timestampRoundedFormat]) {
        data_time_i[timestampRoundedFormat] = [];
      }
      if (!data_time_i[timestampRoundedFormat][endpoint.IEEEAddress]) {
        data_time_i[timestampRoundedFormat][endpoint.IEEEAddress] = [];
      }
      data_time_i[timestampRoundedFormat][endpoint.IEEEAddress].push(endpoint);


      // FORZO A ORE
      timestampRoundedFormat = timestampRounded.format('YYYY-MM-DD HH');
      timestampRoundedFormat = moment(timestampRoundedFormat + ':00:00', 'YYYY-MM-DD HH:mm:ss');

      timestampRoundedFormat = timestampRoundedFormat.format('X');
      endpoint.timestampRounded = timestampRoundedFormat;
      // FINE MODIFICA DATA - POI AGGIUNGO I DATI SOMMANDOLI

      // SMISTAMENTO DATI CON ARROTONDAMENTO
      if (!data_time_h[timestampRoundedFormat]) {
        data_time_h[timestampRoundedFormat] = [];
      }
      if (!data_time_h[timestampRoundedFormat][endpoint.IEEEAddress]) {
        data_time_h[timestampRoundedFormat][endpoint.IEEEAddress] = [];
      }
      data_time_h[timestampRoundedFormat][endpoint.IEEEAddress].push(endpoint);


      // FORZO A GIORNI
      timestampRoundedFormat = timestampRounded.format('YYYY-MM-DD');
      timestampRoundedFormat = moment(timestampRoundedFormat + ' 00:00:00', 'YYYY-MM-DD HH:mm:ss');

      timestampRoundedFormat = timestampRoundedFormat.format('X');
      endpoint.timestampRounded = timestampRoundedFormat;
      // FINE MODIFICA DATA - POI AGGIUNGO I DATI SOMMANDOLI

      // SMISTAMENTO DATI CON ARROTONDAMENTO
      if (!data_time_d[timestampRoundedFormat]) {
        data_time_d[timestampRoundedFormat] = [];
      }
      if (!data_time_d[timestampRoundedFormat][endpoint.IEEEAddress]) {
        data_time_d[timestampRoundedFormat][endpoint.IEEEAddress] = [];
      }
      data_time_d[timestampRoundedFormat][endpoint.IEEEAddress].push(endpoint);

      i++;
    }

    this.setState({
      data_time_d: data_time_d,
      data_time_h: data_time_h,
      data_time_i: data_time_i,
    });
  }

  getDevices() {
    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: 'GetDevices'
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        if (res.Devices) {
          let z = 0;
          let devices = [];
          while (z < res.Devices.length) {
            devices.push(res.Devices[z]);
            z++;
          }

          this.setState({ devices: devices }, () => {
            let i = 0;
            while (i < this.state.devices.length) {
              this.createTunnel(this.state.devices[i].id);
              i++;
            }
          });
        }
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  updateDataAfterAjax(res, deviceID) {
    let devices = this.state.devices;
    let i = 0;
    while (i < devices.length) {
      if (devices[i].id === deviceID) {
        devices[i].subDevices = res.Nodes;
      }
      i++;
    }

    let subDevices = this.state.subDevices;
    let j = 0;
    while (j < res.Nodes.length) {
      subDevices.push(res.Nodes[j]);
      j++;
    }

    let graphData = this.state.graphData;
    let k = 0;
    while (k < res.Nodes.length) {
      let z = 0;
      if (res.Nodes[k].Endpoints) {
        let endpoints = res.Nodes[k].Endpoints;
        let ieeeAddress = res.Nodes[k].IEEEAddress;
        let nome = res.Nodes[k].Description;
        if (!nome) {
          nome = 'Senza nome';
        }
        let j = 0;
        while (z < endpoints.length) {
          let ep = endpoints[z];
          for (var ka in ep) {
            let cod_base = deviceID + '_' + ieeeAddress + '_' + ka;
            let val_base = nome + ' ' + ka;
            let cod;
            let val;
            if((typeof ep[ka] === "object") && (ep[ka] !== null)){
              for (var kk in ep[ka]) {
                cod = cod_base + '_' + kk;
                val = val_base + ' ' + kk;
                let obj = {
                  deviceID: deviceID,
                  IEEEAddress: ieeeAddress,
                  endpointID: ep.Id,
                  added: false,
                  color: '#000',
                  protocol : 'zigbee',
                  name: val,
                  type: cod,
                };
                graphData.push(obj);
              }
            } else {
              let obj = {
                deviceID: deviceID,
                IEEEAddress: ieeeAddress,
                endpointID: ep.Id,
                added: false,
                color: '#000',
                protocol : 'zigbee',
                name: val_base,
                type: cod_base,
              };
              graphData.push(obj);
            }
          }

          z++;
        }
      } else {
        // MODBUS
        let obj = {
          address : res.Nodes[k].address,
          added : false,
          color : '#000',
          deviceID : deviceID,
          name : 'Modbus Battery - ' + res.Nodes[k].name,
          type : 'Modbus.Battery',
          key : res.Nodes[k].key,
          protocol : 'modbus',
          codeName : res.Nodes[k].codeName,
        };
        graphData.push(obj);
      }
      k++;
    }
    graphData.sort(this.alpha);
    this.setState({ devices: devices, subDevices: subDevices, graphData: graphData });
  }

  getSubdevices(deviceID) {
    $.ajax({
      method: 'GET',
      url: this.state.tunnel.URL + '/zigbee/json',
      headers: {
        'x-session': this.props.token,
      },
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      },
      async: false,
      success: (res) => {
        $.ajax({
          method: 'GET',
          url: this.state.tunnel.URL + '/energy/storage/json',
          headers: {
            'x-session': this.props.token,
          },
          dataType: 'json',
          xhrFields: {
            withCredentials: true
          },
          async: false,
          success: (resModbus) => {
            // INIZIO MODBUS
            if (resModbus.length) {
              let i = 0;
              while(i < resModbus.length) {
                let propsNames = Object.getOwnPropertyNames(resModbus[i]);
                let b = 0;
                while (b < propsNames.length) {
                  if (propsNames[b] !== 'Id' && propsNames[b] !== 'Description') {
                    let input = {
                      address : resModbus[i].Id,
                      added : false,
                      color : '#000',
                      deviceID : deviceID,
                      name : resModbus[i].Description + ' - ' + propsNames[b],
                      type : 'Modbus.Battery',
                      key : resModbus[i].Description + '_' + propsNames[b] + '_' + deviceID,
                      code : 'Modbus.Battery_' + resModbus[i].Description + '_' + propsNames[b] + '_' + deviceID,
                      val: resModbus[i][propsNames[b]],
                      codeName : propsNames[b],
                    };
                    res.Nodes.push(input);
                  }

                  b++;
                }
                i++;
              }
            }
            // FINE MODBUS
            this.updateDataAfterAjax(res, deviceID);
          },
          error: (httpReq, status, exception) => {
            console.log(httpReq);
            console.log(status);
            console.log(exception);
            this.updateDataAfterAjax(res, deviceID);
          },
        });
      },
      error: (httpReq, status, exception) => {
        console.log(httpReq);
        console.log(status);
        console.log(exception);
      },
    });
  }

  updateSubdevices() {
    let devices = this.state.devices;

    this.setState({ subDevicesTemp: [] }, () => {
      let i = 0;
      while (i < devices.length) {
        // CREO TUNNEL
        let deviceID = devices[i].id;
        $.ajax({
          method: 'POST',
          url: 'https://sparkjvm.com/cloud/json',
          headers: {
            'x-session': this.props.token,
          },
          data: JSON.stringify({
            Action: 'CreateTunnel',
            DeviceID: deviceID,
          }),
          xhrFields: {
            withCredentials: true
          },
          dataType: 'JSON',
          async: false,
          success: (res) => {
            // CREATO TUNNEL, CERCO DATI SUBDEVICES
            if (res.Tunnel) {
              let tunnelUrl = res.Tunnel.URL;
              $.ajax({
                method: 'GET',
                url: tunnelUrl + '/zigbee/json',
                headers: {
                  'x-session': this.props.token,
                },
                dataType: 'json',
                xhrFields: {
                  withCredentials: true
                },
                async: false,
                success: (res) => {
                  $.ajax({
                    method: 'GET',
                    url: tunnelUrl + '/energy/storage/json',
                    headers: {
                      'x-session': this.props.token,
                    },
                    dataType: 'json',
                    xhrFields: {
                      withCredentials: true
                    },
                    async: false,
                    success: (resModbus) => {
                      // INIZIO MODBUS
                      if (resModbus.length) {
                        let i = 0;
                        while(i < resModbus.length) {
                          let propsNames = Object.getOwnPropertyNames(resModbus[i]);
                          let b = 0;
                          while (b < propsNames.length) {
                            if (propsNames[b] !== 'Id' && propsNames[b] !== 'Description') {
                              let input = {
                                address : resModbus[i].Id,
                                added : false,
                                color : '#000',
                                deviceID : deviceID,
                                name : resModbus[i].Description + ' - ' + propsNames[b],
                                type : 'Modbus.Battery',
                                key : resModbus[i].Description + '_' + propsNames[b] + '_' + deviceID,
                                code : 'Modbus.Battery_' + resModbus[i].Description + '_' + propsNames[b] + '_' + deviceID,
                                val: resModbus[i][propsNames[b]],
                                codeName : propsNames[b],
                              };
                              res.Nodes.push(input);
                            }

                            b++;
                          }
                          i++;
                        }
                      }
                      // FINE MODBUS
                      let j = 0;
                      let subDevicesTemp = this.state.subDevicesTemp;
                      while (j < res.Nodes.length) {
                        subDevicesTemp.push(res.Nodes[j]);
                        j++;
                      }
                      this.setState({ subDevicesTemp: subDevicesTemp });
                    },
                    error: (httpReq, status, exception) => {
                      console.log(httpReq);
                      console.log(status);
                      console.log(exception);
                      let j = 0;
                      let subDevicesTemp = this.state.subDevicesTemp;
                      while (j < res.Nodes.length) {
                        subDevicesTemp.push(res.Nodes[j]);
                        j++;
                      }
                      this.setState({ subDevicesTemp: subDevicesTemp });
                    },
                  });
                },
                error: (httpReq, status, exception) => {
                  console.log(httpReq);
                  console.log(status);
                  console.log(exception);
                },
              });
            }
          },
          error: (httpReq, status, exception) => {
            this.checkLoginStatus();
          },
        });

        i++;
      }
    });
    this.setState({ subDevices: this.state.subDevicesTemp });
  }

  alpha(a, b) {
    if (a.name < b.name)
      return -1;
    if (a.name > b.name)
      return 1;
    return 0;
  }

  getObjFromEndpoint(params, string, name, deviceID, IEEEAddress, endpoint, array) {
    let i = 0;
    let val = endpoint;
    let add = true;
    while (i < params.length) {
      if (val.hasOwnProperty(params[i])) {
        val = val[params[i]];
      } else {
        add = false;
      }
      i++;
    }

    if (!name) {
      name = deviceID;
    }
    let obj;
    if (add) {
      obj = {
        name: name,
        deviceID: deviceID,
        IEEEAddress: IEEEAddress,
        endpointID: endpoint.Id,
        added: false,
        type: string,
        color: '#000',
        protocol : 'zigbee',
      };
      array.push(obj);
    }
    return array;
  }

  createTunnel(deviceID) {
    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: 'CreateTunnel',
        DeviceID: deviceID,
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        if (res.Tunnel) {
          this.setState({ tunnel: res.Tunnel }, () => {
            this.getSubdevices(deviceID);
          });
        }
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  changeDataGroup(e) {
    this.setState({ dataGroup : e.target.value });
  }

  changeHours(e) {
    this.setState({ hours : e.target.value });
  }

  removeModule(id) {
    let modules = [];
    let i = 0;
    while (i < this.state.modules.length) {
      if (this.state.modules[i].id !== id) {
        modules.push(this.state.modules[i]);
      }
      i++;
    }
    this.setState({ modules: modules });
    this.saveGraphsToDb(modules);
  }

  saveGraphsToDb(modules) {
    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: 'UpdateUserInfo',
        Email: this.state.userEmail,
        Extra: btoa(JSON.stringify(modules)),
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res, status, jqXHR) => {
        this.setState({ modules: modules });
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  checkAjaxOpen() {
    let ret = true;
    for (var k in this.state.ajaxOpen) {
      if (this.state.ajaxOpen[k] != 0) {
        ret = false;
      }
    }
    return ret;
  }

  renderHours() {
    if (this.state.dataGroup === '1i') {
      return(
        <div className="dashboard__search__col">
          <span className="dashboard__search__col__label">Seleziona orario</span>
          <select value={ this.state.hours } onChange={ this.changeHours }>
            <option value="00-01">00:00 - 01:00</option>
            <option value="01-02">01:00 - 02:00</option>
            <option value="02-03">02:00 - 03:00</option>
            <option value="03-04">03:00 - 04:00</option>
            <option value="04-05">04:00 - 05:00</option>
            <option value="05-06">05:00 - 06:00</option>
            <option value="06-07">06:00 - 07:00</option>
            <option value="07-08">07:00 - 08:00</option>
            <option value="08-09">08:00 - 09:00</option>
            <option value="09-10">09:00 - 10:00</option>
            <option value="10-11">10:00 - 11:00</option>
            <option value="11-12">11:00 - 12:00</option>
            <option value="12-13">12:00 - 13:00</option>
            <option value="13-14">13:00 - 14:00</option>
            <option value="14-15">14:00 - 15:00</option>
            <option value="15-16">15:00 - 16:00</option>
            <option value="16-17">16:00 - 17:00</option>
            <option value="17-18">17:00 - 18:00</option>
            <option value="18-19">18:00 - 19:00</option>
            <option value="19-20">19:00 - 20:00</option>
            <option value="20-21">20:00 - 21:00</option>
            <option value="21-22">21:00 - 22:00</option>
            <option value="22-23">22:00 - 23:00</option>
            <option value="23-00">23:00 - 00:00</option>
          </select>
        </div>
      )
    }
    return '';
  }

  renderDashboard() {
    let dashboard = '';
    if(this.state.modules.length) {
      let i = 0;
      dashboard = this.state.modules.map((mod) => {
        let ret = '';
        i++;
        let id = 'mod-' + i;

        return(
          <div className="dashboard__resume" key={ id }>
            <div className="dashboard__resume__title">{ mod.title }</div>
            <ul className="dashboard__resume__list">
              { this.renderModules(mod) }
            </ul>
            <div className="dashboard__resume__block">
              <span className="dashboard__resume__details" onClick={ () => { this.openModule(mod, 'bar') } }>
                <span className="dashboard__resume__details__tooltip">Grafico a barre</span>
                <FontAwesome
                  className='dashboard__resume__details__icon'
                  name='chart-bar'
                />
              </span>
              <span className="dashboard__resume__details" onClick={ () => { this.openModule(mod, 'line') } }>
                <span className="dashboard__resume__details__tooltip">Grafico a linee</span>
                <FontAwesome
                  className='dashboard__resume__details__icon'
                  name='chart-line'
                />
              </span>
              <span className="dashboard__resume__details" onClick={ () => { this.openModule(mod, 'pie') } }>
                <span className="dashboard__resume__details__tooltip">Grafico a torta</span>
                <FontAwesome
                  className='dashboard__resume__details__icon'
                  name='chart-pie'
                />
              </span>
              <span className="dashboard__resume__details" onClick={ () => { this.editModule(mod) } }>
                <span className="dashboard__resume__details__tooltip">Modifica modulo</span>
                <FontAwesome
                  className='dashboard__resume__details__icon'
                  name='edit'
                />
              </span>
              <span className="dashboard__resume__delete" onClick={ () => { this.removeModule(mod.id) } }>
                <span className="dashboard__resume__details__tooltip">Elimina modulo</span>
                <FontAwesome
                  className='dashboard__resume__delete__icon'
                  name='trash'
                />
              </span>
            </div>
          </div>
        );
      });
    }
    return dashboard;
  }

  editModule(mod) {
    this.setState({editModule: mod}, () => {
      this.forceUpdate();
    });
  }

  openModule(mod, type) {
    mod.chartType = type;
    let i = 0;
    let devicesToQuery = [];
    let address = [];
    while (i < mod.data.length) {
      if (devicesToQuery.indexOf(mod.data[i].deviceID) === -1) {
        devicesToQuery.push(mod.data[i].deviceID);
      }
      if (mod.data[i].IEEEAddress) {
        address.push(mod.data[i].IEEEAddress);
      } else if(mod.data[i].address) {
        address.push(mod.data[i].address);
      }
      i++;
    }

    i = 0;
    this.setState({ openAjax: devicesToQuery.length, address: address, currentGraph: mod }, () => {
      while (i < devicesToQuery.length) {
        this.getSavedData(devicesToQuery[i]);
        i++;
      }
    });
  }

  renderModules(mod) {
    let a = 0;
    let ret = mod.data.map((data) => {
      a++;
      let id = 'mod-name-' + a;
      return(
        <li className="dashboard__resume__list__line" key={ id }>{ data.name } <span style={{ color: data.color }}>{ this.getValueFromDashboardObj(data) }</span></li>
      );
    });
    return ret;
  }

  getValueFromDashboardObj(obj) {
    let sub = this.state.subDevices;
    let i = 0;
    let val = '';
    while (i < sub.length) {
      if (obj.protocol === 'zigbee') {
        if (obj.IEEEAddress === sub[i].IEEEAddress) {
          let z = 0;
          while (z < sub[i].Endpoints.length) {
            let ep = sub[i].Endpoints[z];
            if (ep.Id === obj.endpointID) {
              let params = obj.type.split('_');
              // REMOVE DEVICE ID
              params.shift();
              // REMOVE IEEADDRESS
              params.shift();
              let ii = 0;
              let err = false;
              while (ii < params.length) {
                if (ep.hasOwnProperty(params[ii])) {
                  ep = ep[params[ii]];
                } else {
                  err = true;
                }
                ii++;
              }
              if (!err) {
                val = ep;
              }
            }
            z++;
          }
        }
      } else if (obj.protocol === 'modbus') {
        if (obj.address === sub[i].address && obj.key === sub[i].key) {
          val = sub[i].val;
        }
      }
      i++;
    }
    return val;
  }

  refreshDashboard() {
    this.forceUpdate();
  }

  renderPopupGraph() {
    if (this.state.popupGraph) {
      if (this.state.currentGraph.chartType === 'bar') {
        return(
          <div className="overlay">
            <div className="overlay__shadow" onClick={ () => { this.setState({ popupGraph: false }); } }></div>
            <div className="overlay__content overlay__content--padded">
              <BarChart graph={ this.state.currentGraph } token={ this.props.token } />
            </div>
          </div>
        );
      } else if (this.state.currentGraph.chartType === 'line') {
        return(
          <div className="overlay">
            <div className="overlay__shadow" onClick={ () => { this.setState({ popupGraph: false }); } }></div>
            <div className="overlay__content overlay__content--padded">
              <LineChart graph={ this.state.currentGraph } token={ this.props.token } />
            </div>
          </div>
        );
      } else if (this.state.currentGraph.chartType === 'pie') {
        return(
          <div className="overlay">
            <div className="overlay__shadow" onClick={ () => { this.setState({ popupGraph: false }); } }></div>
            <div className="overlay__content overlay__content--padded">
              <PieChart graph={ this.state.currentGraph } token={ this.props.token } />
            </div>
          </div>
        );
      }
    }
    return '';
  }

  removeEditModule() {
    this.setState({ editModule: {} });
  }

  render() {
    return (
      <BaseTemplate>
        <h1>Dashboard</h1>
        <DashboardAddModule graphData={ this.state.graphData } modules={ this.state.modules } saveGraphsToDb={ this.saveGraphsToDb } editModule={ this.state.editModule } removeEditModule={ this.removeEditModule } />
        <div className="dashboard">
          { this.renderDashboard() }
        </div>
        { this.renderPopupGraph() }
      </BaseTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard.js